module.exports = __webpack_public_path__ + "img/PEN.b49d4752.svg";